const NEAR_BOTTOM_PX = 120

function isNearBottom(el) {
  return el.scrollHeight - el.scrollTop - el.clientHeight < NEAR_BOTTOM_PX
}

export default {
  mounted() {
    this.stick = true
    this.onScroll = () => { this.stick = isNearBottom(this.el) }
    this.el.addEventListener("scroll", this.onScroll, { passive: true })
    this.scrollToBottom()
  },
  updated() {
    if (this.stick) this.scrollToBottom()
  },
  // Defer to the next frame so content that lays out late (streamed
  // markdown, code blocks, images) is measured before we pin to the bottom.
  scrollToBottom() {
    requestAnimationFrame(() => {
      this.el.scrollTop = this.el.scrollHeight
    })
  },
  destroyed() {
    if (this.onScroll) this.el.removeEventListener("scroll", this.onScroll)
  }
}
